var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoveExchanges = function SvgMoveExchanges(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.36 16.6a1 1 0 0 0 1.16 0l5.88-4.19a1 1 0 0 0 .37-1.13l-2.24-6.77a1 1 0 0 0-.95-.69H6.3a1 1 0 0 0-.95.69l-2.24 6.77a1 1 0 0 0 .37 1.13l5.88 4.18Z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.34 9.94 1.52 8.43a1 1 0 0 1-.3-1.08L3.1 1.68A1 1 0 0 1 4.06 1h6.12a1 1 0 0 1 .95.69l.7 2.13M8.65 7.59l2.7 2.53-2.7 2.54M3.82 10.18h6.09",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgMoveExchanges;